import {SHIPMENTS_LOAD, REMOVE_SHIPMENTS, SET_ACTIVE_SEARCH, REMOVE_ACTIVE_SEARCH} from '../actions';
import {ActionWithPayload} from './index';
import {AppState} from '@store/reducers/index';
import {
  SHIPMENT_PAGE_LOAD,
  SHIPMENTS_SHIPMENT_REMOVE,

  SHIPMENT_SELECT,
  SHIPMENT_PAGE_SELECT,
  LOAD_SHIPMENTS_AFTER_REMOVAL,

  SET_FILTERED_SHIPMENTS,
  CLEAR_SHIPMENTS_STATE
} from '@store/actions/shipments.action';
import {Shipment} from '@models/shipment.interface';
import 'rxjs/add/operator/map';

export enum ShipmentTypes {
  SAVED = 'SAVED',
  BOOKED = 'BOOKED',
  ONGOING = 'ONGOING',
  DELIVERED = 'DELIVERED'
}

export type ShipmentsState = {
  [key in ShipmentTypes]: PaginationState;
};

export interface PaginationState {
  type: ShipmentTypes;
  total: number;
  current_page_size: number;
  current_page: number;
  activeSearch: string;
  data: {
    [key: number]: {
      [key: number]: Shipment[]
    }
  };
  filteredData: {
    [search: string]: {
      total: number,
      data: {
        [key: number]: {
          [key: number]: Shipment[]
        }
      }
    }
  };
}

interface Payload extends PaginationState {
  isSelected?: boolean,
  id?: string
}


export function shipmentsReducer(
  state = {
    [ShipmentTypes.SAVED]: null,
    [ShipmentTypes.BOOKED]: null,
    [ShipmentTypes.ONGOING]: null,
    [ShipmentTypes.DELIVERED]: null,
    activeSearch: null,
  }, action: ActionWithPayload<Payload>) {
  switch (action.type) {
    case SHIPMENTS_LOAD:
      return {
        ...state,
        [action.payload.type]: action.payload,
      };

    case SHIPMENT_PAGE_LOAD:
      const data = state[action.payload.type] ? state[action.payload.type].data : {};
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          type: action.payload.type,
          total: action.payload.total,
          current_page: action.payload.current_page,
          current_page_size: action.payload.current_page_size,
          data: {
            ...data,
            [action.payload.current_page_size]: {
              ...data[action.payload.current_page_size],
              [action.payload.current_page]: action.payload.data
            }
          }
        },
      };
    case SHIPMENT_SELECT:
      let shipments1: Shipment[] =
        [...state[action.payload.type].data[action.payload.current_page_size][action.payload.current_page]];

      const selectedShipment = (shipments1.find(({id}) => id == action.payload.id) as Shipment);
      selectedShipment.selected = !selectedShipment.selected;
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          data: {
            ...data,
            [action.payload.current_page_size]: {
              ...state[action.payload.type].data[action.payload.current_page_size],
              [action.payload.current_page]: shipments1
            }
          }
        },
      };

    case SHIPMENT_PAGE_SELECT:
      let shipments2 =
        [...state[action.payload.type].data[action.payload.current_page_size][action.payload.current_page]]
          .map(shipment => ({...shipment, selected: action.payload.isSelected}));
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          data: {
            ...data,
            [action.payload.current_page_size]: {
              ...state[action.payload.type][action.payload.current_page_size],
              [action.payload.current_page]: shipments2
            }
          }
        },
      };

    case LOAD_SHIPMENTS_AFTER_REMOVAL:
      const pages3 = {};
      // find first page with selected shipment
      let start_page = Object.keys(state[action.payload.type].data[action.payload.current_page_size])
        .find(key => {
          return state[action.payload.type].data[action.payload.current_page_size][key]
            .some(({selected}) => selected);
        });
      // remove all pages after start_page
      Object.keys(state[action.payload.type].data[action.payload.current_page_size]).forEach(key => {
        if (key < start_page) {
          pages3[key] = state[action.payload.type].data[action.payload.current_page_size][key];
        }
      });
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          data: {
            ...data,
            [action.payload.current_page_size]: pages3
          }
        },
      };

    case SET_ACTIVE_SEARCH:
      let filteredData1 = state[action.payload.type].filteredData;
      if (!state[action.payload.type].filteredData) {
        filteredData1 = {
          [action.payload.activeSearch]: {
            total: null,
            data: {
              [action.payload.current_page_size]: {
                [action.payload.current_page]: []
              }
            }
          }
        };
      } else if (!state[action.payload.type].filteredData[action.payload.activeSearch]) {
        filteredData1 = {
          ...state[action.payload.type].filteredData,
          [action.payload.activeSearch]: {
            total: null,
            data: {
              [action.payload.current_page_size]: {
                [action.payload.current_page]: []
              }
            }
          }
        };
      }
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          activeSearch: action.payload.activeSearch,
          filteredData: {
            ...filteredData1,
            [action.payload.activeSearch]: {
              total: null,
              data: {
                [action.payload.current_page_size]: {
                  ...filteredData1[action.payload.activeSearch].data[action.payload.current_page_size],
                  [action.payload.current_page]: []
                }
              }
            }
          }
        }
      };
    case SET_FILTERED_SHIPMENTS:
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          current_page: action.payload.current_page,
          filteredData: {
            ...state[action.payload.type].filteredData,
            [action.payload.activeSearch]: {
              total: action.payload.total,
              data: {
                [action.payload.current_page_size]: {
                  ...state[action.payload.type].filteredData[action.payload.activeSearch].data[action.payload.current_page_size],
                  [action.payload.current_page]: action.payload.data
                }
              }
            }
          }
        },
      };
    case REMOVE_ACTIVE_SEARCH:
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          activeSearch: null,
          current_page: 1
        }
      };
    case CLEAR_SHIPMENTS_STATE:
      return {
        [ShipmentTypes.SAVED]: null,
        [ShipmentTypes.BOOKED]: null,
        [ShipmentTypes.ONGOING]: null,
        [ShipmentTypes.DELIVERED]: null,
        activeSearch: null,
      };
    default:
      return state;
  }
}

export const selectSavedShipments = (state: AppState) => state.shipments[ShipmentTypes.SAVED];
export const selectBookedShipments = (state: AppState) => state.shipments[ShipmentTypes.BOOKED];
export const selectOngoingShipments = (state: AppState) => state.shipments[ShipmentTypes.ONGOING];
export const selectDeliveredShipments = (state: AppState) => state.shipments[ShipmentTypes.DELIVERED];



// WEBPACK FOOTER //
// ./src/app/store/reducers/shipments.reducer.ts